import { useTranslation } from 'react-i18next';
import { Share as ShareIcon } from '@vgno/icons';

import { isNativeShareSupported, share } from '../../helpers/share';
import { Button } from '../Button/Button';
import { appendQueryParams } from '../../shared/helpers/url';

import type { FC } from 'react';

import * as styles from './ShareButton.module.scss';

function shareAsset(url: string, title: string) {
  return share({ url, title }).catch((error) => {
    console.error(error);
  });
}

interface Props {
  url?: string;
  title: string;
}

export const ShareButton: FC<Props> = ({ url, title }) => {
  const { t } = useTranslation();

  if (!url || !isNativeShareSupported()) {
    return null;
  }

  const shareUrl = appendQueryParams(url, {
    utm_source: 'portal-share-button',
  });

  return (
    <Button
      size="small"
      variant="text"
      className={styles.button}
      onClick={() => shareAsset(shareUrl, title)}
    >
      <ShareIcon />
      {t('share')}
    </Button>
  );
};
